module.exports = __webpack_public_path__ + "img/vuejs.4203db39.png";